/**
 * The questions a till asks: size, extras, which drink.
 *
 * Read at the till, so it is cached hard — a menu's modifier groups change when
 * somebody edits the menu, which is not during a lunch rush.
 */

import { api } from "@/api/client";

export interface Modifier {
  id: string;
  group: string;
  name: string;
  price_delta: string;
  component: string | null;
  component_name: string;
  component_quantity: string;
  is_default: boolean;
  sort_order: number;
  is_active: boolean;
}

export interface ModifierGroup {
  id: string;
  name: string;
  products: string[];
  minimum: number;
  maximum: number;
  /** `minimum > 0`. A size, rather than an extra. */
  is_required: boolean;
  /** `maximum !== 1`. Checkboxes rather than a single choice. */
  allows_many: boolean;
  sort_order: number;
  is_active: boolean;
  modifiers: Modifier[];
}

interface Page<T> {
  count: number;
  next: string | null;
  results: T[];
}

function unwrap<T>(payload: Page<T> | T[]): T[] {
  return Array.isArray(payload) ? payload : payload.results;
}

export const modifiersRepository = {
  /** Every group this shop has, with its choices. Small enough to fetch whole. */
  all: async (): Promise<ModifierGroup[]> =>
    unwrap(await api.get<Page<ModifierGroup> | ModifierGroup[]>("/modifier-groups/")),

  forProduct: async (productId: string): Promise<ModifierGroup[]> =>
    unwrap(
      await api.get<Page<ModifierGroup> | ModifierGroup[]>(`/modifier-groups/?product=${productId}`),
    ),
};
